import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../config";

const PageTransition = ({ children }) => {
  return (
    <>
      {/* Page Content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, delay: 0.8 }}
      >
        {children}
      </motion.div>

      {/* Entry animation - Logo centered */}
      <motion.div
        className="fixed inset-0 z-[100] pointer-events-none flex items-center justify-center bg-[#fafafa]"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{ duration: 0.3, delay: 0.6 }}
      >
        {/* Bar Spot Logo - centered */}
        <motion.div
          className="flex flex-col items-center justify-center"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: [0, 1, 1, 0], scale: [0.8, 1, 1, 0.95] }}
          transition={{ duration: 0.8, times: [0, 0.2, 0.7, 1] }}
        >
          <img 
            src={IMAGES.barspotLogoRound} 
            alt="" 
            aria-hidden="true"
            className="w-32 h-32 md:w-44 md:h-44 rounded-full shadow-2xl border-4 border-white"
          />
        </motion.div>
      </motion.div>
    </>
  );
};

export default PageTransition;
